export const required = (label: string) => (value: string) => (value ? undefined : label);
